var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['v-tabs', { 'v-tabs--primary': _vm.primary }],attrs:{"body-scroll-lock-ignore":""}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }